export default __webpack_public_path__ + "static/media/sweet2.9e8c7fdd.jpg";